/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import './backDrop.css';


interface Props{
    clicked:  ()=> void;
    show:boolean;
};

const BackDrop : React.FC<Props> = ({ clicked,show })=> show? <div className="BackDrop" onClick={clicked}>a</div>: null

export default BackDrop;
